import * as FlyActions from './actions'

export default {
  ...FlyActions
}
